// extracted by mini-css-extract-plugin
module.exports = {"map":"map_map__y4Qfq","leafletMap":"map_leafletMap__tCR9l","pointer":"map_pointer__ygiQF"};